/** @namespace */
var Tremol = require("./fp");
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (search, this_len) {
        if (this_len === undefined || this_len > this.length) {
            this_len = this.length;
        }
        return this.substring(this_len - search.length, this_len) === search;
    };
}

/**
 * @function
 * @param {Number} id 
 * @param {String} fdname 
 * @param {Number} fdcode 
 * @param {Number} amount 
 * @param {Number} exchangeRate 
 */
function NRAPayment(id, fdname, fdcode, amount, exchangeRate) {
    /** @type {Number} ID на плащането */
    this.id = id;
    /** @type {String} Име на плащането */
    this.fdname = fdname;
    /** @type {String} Обща сума по този тип плащане (при четене на регистри, съдържащи такава информация) */
    this.amount = amount;
    /** @type {Number} Валутен курс */
    this.currencyRate = exchangeRate;
    /** @type {Number} Код на плащането, който трябва да се подаде към ФУ */
    this.fdcode = fdcode;
    this.getFDCode = function () {
        if (this.fdcode === null) {
            throw new Tremol.ServerError("Това плащане не е програмирано във ФУ!", Tremol.ServerErrorType.PaymentNotSupported);
        } else {
            return this.fdcode;
        }
    }
}

var NRAPayments = function (fdnames, fdcodes, paymentAmounts, exchangeRate) {
    /** В брой */
    this.SCash = new NRAPayment(0, fdnames[0], fdcodes[0], paymentAmounts[0], null);
    /** С чек */
    this.SChecks = new NRAPayment(1, fdnames[1], fdcodes[1], paymentAmounts[1], null);
    /** Талони */
    this.ST = new NRAPayment(2, fdnames[2], fdcodes[2], paymentAmounts[2], null);
    /** Сума по външни талони */
    this.SOT = new NRAPayment(3, fdnames[3], fdcodes[3], paymentAmounts[3], null);
    /** Сума по амбалаж */
    this.SP = new NRAPayment(4, fdnames[4], fdcodes[4], paymentAmounts[4], null);
    /** Сума по вътрешно обслужване */
    this.SSelf = new NRAPayment(5, fdnames[5], fdcodes[5], paymentAmounts[5], null);
    /** Сума по повреди */
    this.SDmg = new NRAPayment(6, fdnames[6], fdcodes[6], paymentAmounts[6], null);
    /** Сума по кредитни/ дебитни карти */
    this.SCards = new NRAPayment(7, fdnames[7], fdcodes[7], paymentAmounts[7], null);
    /** Сума по банкови трансфери */
    this.SW = new NRAPayment(8, fdnames[8], fdcodes[8], paymentAmounts[8], null);
    /** Резерв 1 */
    this.SR1 = new NRAPayment(9, fdnames[9], fdcodes[9], paymentAmounts[9], null);
    /** Резерв 2 */
    this.SR2 = new NRAPayment(10, fdnames[10], fdcodes[10], paymentAmounts[10], null);
    /** Валутно плащане, което не е по номенклатурата на НАП */
    this.CURRENCY = new NRAPayment(11, fdnames[11], fdcodes[11], paymentAmounts[11], exchangeRate);

    this.toArray = () => {
        var r = [];
        Object.keys(this).forEach((key) => {
            r.push(Object.assign({}, this[key]));
        });
        return r;
    }
}

Tremol.FP.prototype.Ext_IsNEW = async function () {
    return !(await this.ReadVersion()).Model.endsWith("V2");
}

Tremol.FP.prototype.Ext_GetNRAPayments = async function (isFpNew, amounts) {
    var paymentNames = [];
    var paymentAmounts = [];
    var paymentFDCodes = [];
    var exchangeRate = null;

    try {
        var ppos = Object.values(await this.ReadPaymentsPositions());
        for (var p = 0; p < 12; p++) {
            paymentFDCodes[ppos[p]] = p;
        }
    }
    catch {
        for (var i = 0; i < 12; i++) {
            paymentNames[i] = null;
            paymentAmounts[i] = null;
            if (isFpNew) {
                paymentFDCodes[i] = String(i);
            } else {
                paymentFDCodes[i] = null;
            }
        }
    }

    if (isFpNew) {
        var paymRes = await this.ReadPayments();
        paymentNames[0] = paymRes.NamePayment0;
        paymentNames[1] = paymRes.NamePayment1;
        paymentNames[2] = paymRes.NamePayment2;
        paymentNames[3] = paymRes.NamePayment3;
        paymentNames[4] = paymRes.NamePayment4;
        paymentNames[5] = paymRes.NamePayment5;
        paymentNames[6] = paymRes.NamePayment6;
        paymentNames[7] = paymRes.NamePayment7;
        paymentNames[8] = paymRes.NamePayment8;
        paymentNames[9] = paymRes.NamePayment9;
        paymentNames[10] = paymRes.NamePayment10;
        paymentNames[11] = paymRes.NamePayment11;
        exchangeRate = paymRes.ExchangeRate;
        if (amounts !== null) {
            paymentAmounts = amounts;
        }
    } else {
        var paymResOld = await this.ReadPayments_Old();
        paymentNames[0 /** В брой */] = paymResOld.NamePaym0;
        paymentNames[Number(paymResOld.CodePaym1)] = paymResOld.NamePaym1;
        paymentNames[Number(paymResOld.CodePaym2)] = paymResOld.NamePaym2;
        paymentNames[Number(paymResOld.CodePaym3)] = paymResOld.NamePaym3;
        paymentNames[11  /** Валута */] = paymResOld.NamePaym4;
        exchangeRate = paymResOld.ExRate;

        paymentFDCodes[0] = '0';
        paymentFDCodes[Number(paymResOld.CodePaym1)] = '1';
        paymentFDCodes[Number(paymResOld.CodePaym2)] = '2';
        paymentFDCodes[Number(paymResOld.CodePaym3)] = '3';
        paymentFDCodes[11] = '4';

        if (amounts !== null) {
            paymentAmounts[0 /** В брой */] = amounts[0];
            paymentAmounts[Number(paymResOld.CodePaym1)] = amounts[1];
            paymentAmounts[Number(paymResOld.CodePaym2)] = amounts[2];
            paymentAmounts[Number(paymResOld.CodePaym3)] = amounts[3];
            paymentAmounts[11  /** Валута */] = amounts[4];
        }
    }
    return new NRAPayments(paymentNames, paymentFDCodes, paymentAmounts, exchangeRate);
}

/**
 * @return {String} QR кода от последния бон
 */
Tremol.FP.prototype.Ext_PayWithCardAndCloseReceipt = async function () {
    var amount = await this.Subtotal(Tremol.Enums.OptionPrinting.No, Tremol.Enums.OptionDisplay.Yes);
    var isNew = await this.Ext_IsNEW();
    var payments = await this.Ext_GetNRAPayments(isNew, null);
    await this.Payment(payments.SCards.getFDCode(), Tremol.Enums.With_Change, amount, null);
    await this.CloseReceipt();
    return await this.ReadLastReceiptQRcodeData();
}

Tremol.FP.prototype.Ext_WaitIfBusy = async function (timeout) {
    var start = new Date().getTime();
    var fn = async () => {
        return new Promise((resolve) => {
            this.RawWrite(new Uint8Array([0x09])).then(() => {
                this.RawRead(1, undefined).then((res) => {
                    if (res[0] == 0x40) {
                        resolve(true);
                    } else if (new Date().getTime() < start + timeout) {
                        resolve(false);
                    }
                    else {
                        setTimeout(fn, 150);
                    }
                })
            }).catch(() => {
                return false;
            })

        });
    }
    return await fn();
}

Tremol.FP.prototype.Ext_ReadDailyAvailableAmounts = async function () {
    /** @type {NRAPayments} */
    var payRes = null;
    if (await this.Ext_IsNEW()) {
        var res = await this.ReadDailyAvailableAmounts();
        var amounts = [res.AmountPayment0,
        res.AmountPayment1,
        res.AmountPayment2,
        res.AmountPayment3,
        res.AmountPayment4,
        res.AmountPayment5,
        res.AmountPayment6,
        res.AmountPayment7,
        res.AmountPayment8,
        res.AmountPayment9,
        res.AmountPayment10,
        res.AmountPayment11];
        payRes = await this.Ext_GetNRAPayments(true, amounts);
    }
    else {
        var resOld = await this.ReadDailyAvailableAmounts_Old();
        var amountsOld = [resOld.AmountPayment0,
        resOld.AmountPayment1,
        resOld.AmountPayment2,
        resOld.AmountPayment3,
        resOld.AmountPayment4];
        payRes = await this.Ext_GetNRAPayments(false, amountsOld);
    }
    return payRes;
}

Tremol.FP.prototype.Ext_CanOpenReceipt = async function () {
    var s = await this.ReadStatus();
    return !s.Blocking_3_days_without_mobile_operator
        && !s.DateTime_not_set && !s.DateTime_wrong
        && !s.FM_error && !s.FM_full && !s.FM_Read_only && !s.No_FM_module
        && !s.Hardware_clock_error
        && !s.No_GPRS_Modem && !s.No_SIM_card
        && !s.No_task_from_NRA
        && !s.Opened_Non_fiscal_Receipt && !s.Opened_Fiscal_Receipt
        && !s.Opened_Invoice_Fiscal_Receipt
        && !s.Printer_not_ready_no_paper
        && !s.Printer_not_ready_overheat
        && !s.RAM_reset
        && !s.Reports_registers_Overflow
        && !s.SD_card_full
        && !s.Unsent_data_for_24_hours
        && !s.Wrong_SIM_card
        && !s.Wrong_SD_card;
}

module.exports = Tremol